var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagnifyblack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-465.000000, -534.000000) translate(140.000000, 150.000000) translate(324.000000, 383.000000)",
    stroke: "currentColor",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.300000, 2.300000)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1,
    d: "M14.1404 14.0898L18.3586 18.308"
  }), /*#__PURE__*/React.createElement("circle", {
    strokeWidth: 1,
    cx: 8.096,
    cy: 8.147,
    r: 8.055
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.159081, 10.767193) rotate(45.000000) translate(-10.159081, -10.767193) translate(8.159081, 8.267193)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.92,
    d: "M0.0476345597 0.115L3.95763456 4.025"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.92,
    d: "M0.0476345597 4.025L3.95763456 0.115"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyblack);
export default __webpack_public_path__ + "static/media/Magnify black.8b89feb4ce385b9f518fc6f7e5c48b5d.svg";
export { ForwardRef as ReactComponent };